export class BoardApprovalActionConstants {
    static readonly APPROVE = 'approved';
    static readonly APPROVE_WITH_STIPULATION = 'approvedcomment';
    static readonly DENY_OR_REQUEST = 'denied';
    static readonly PLACE_IN_REVIEW = 'hold';

    static readonly GREEN_CHECK = 'GREEN_CHECK';
    static readonly RED_CROSS = 'RED_CROSS';
    static readonly WARNING = 'WARNING';

    static readonly APPROVE_TITLE = 'Approved';
    static readonly APPROVE_WITH_STIPULATION_TITLE = 'ApprovedComment';
    static readonly DENY_ADDITIONAL_INFORMATION_TITLE = 'Denied';
    static readonly IN_REVIEW_TITLE = 'Hold';
}
